<template>
  <v-container>
    <v-btn text @click="back">
      <v-icon left>mdi-arrow-left</v-icon>
      一覧に戻る
    </v-btn>
    <v-row>
      <v-col class="mt-6 ml-4">
        <h1 class="display-1 font-weight-bold">
          <div v-if="uuid">
            <div>
              編集
            </div>
            <div class="text-caption">
              id: {{ uuid }}
            </div>
          </div>
          <div v-else>新規作成</div>
        </h1>
      </v-col>
    </v-row>
    <v-container>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      class="ml-2"
    >
      <!-- タイトル -->
      <v-text-field
        v-model="form.title"
        :rules="rules.required"
        label="タイトル"
      ></v-text-field>
      <!-- 動画ファイル -->
      <h2 class="mt-2">動画ファイル</h2>
      <v-btn v-if="uuid&&!changeVideo" @click="changeVideo=true" color="primary">動画を差し替える</v-btn>
      <v-file-input
        v-else
        v-model="form.video"
        label="動画ファイル"
        prepend-icon="mdi-video"
        accept="video/*"
        ref="fileinputVideo"
        :rules="rules.required"
      >
        <template v-slot:append v-if="uuid">
          <v-btn @click="changeVideo=false" color="warning">
            <v-icon left>mdi-close</v-icon>
            キャンセル
          </v-btn>
        </template>
      </v-file-input>
      <!-- サムネイル -->
      <h2 class="mt-4">サムネイル</h2>
      <picture-input 
        ref="pictureInput"
        width="240" 
        height="135" 
        margin="16" 
        accept="image/jpeg,image/png" 
        button-class="v-btn primary v-size--small"
        :prefill="prefill"
        :prefillOptions="prefillOptions"
        :crop="false"
        :custom-strings="{
          drag: 'クリックしてファイル選択',
          change: 'サムネイル変更',
        }"
        @change="change"
        >
      </picture-input>
      <!-- 添付資料 -->
      <h2 class="mt-2">添付資料</h2>
      <div class="my-2">登録されているファイル: {{ attachment ? attachment : 'なし' }}</div>
      <v-btn v-if="uuid&&!changeAttachment" @click="setChangeAttachment()" color="primary">
        {{ attachment ? '添付資料を差し替える' : '添付資料を登録する' }}
      </v-btn>
      <v-file-input
        v-else
        v-model="form.attachment"
        label="添付資料"
        prepend-icon="mdi-attachment"
        ref="fileinputAttachment"
      >
        <template v-slot:append v-if="uuid">
          <v-btn @click="changeAttachment=false" color="warning">
            <v-icon left>mdi-close</v-icon>
            キャンセル
          </v-btn>
        </template>
      </v-file-input>
      <v-btn v-if="uuid&&!changeAttachment&&attachment" @click="setDeleteAttachment()" color="error" class="ml-2">
        添付資料を削除する
      </v-btn>
      <v-alert v-if="error" type="error" dense>{{ error }}</v-alert>
    </v-form>
    <div class="mt-12">
      <v-btn class="mr-4" color="success" @click="send" :loading="loading">登録</v-btn>
      <v-btn color="warning" @click="back">キャンセル</v-btn>
    </div>
    </v-container>
  </v-container>
</template>

<script>
import axios from "axios";
import PictureInput from 'vue-picture-input'

export default {
  components: {
    PictureInput,
  },
  props: ['uuid'],
  data:() => ({
    error: '',
    valid: false,
    loading: false,
    form: {
      title: '',
      video: undefined,
      attachment: undefined,
    },
    rules: {
      required: [v => !!v || '入力してください。'],
    },
    prefill: null,
    prefillOptions: {},

    attachment: '',

    changeVideo: false,
    changeAttachment: false,
    deleteAttachment: false,
    changeThumb: false,
  }),
  created() {
    if (this.uuid) {
      this.fetch()

      // サムネイル情報取得
      axios.head(`/v/${this.uuid}/thumb`).then((response) => {
        this.prefillOptions = {
          mediaType: response.headers['content-type']
        }
      }).finally(() => {
        this.prefill = `/v/${this.uuid}/thumb`
      })
    }
  },
  methods: {
    back() {
      this.$router.push({name:'List'})
    },
    send() {
      this.error = ''
      if (this.$refs.form.validate()) {
        if (this.$refs.pictureInput.file) {
          if (this.uuid) { // 更新
            if (this.changeAttachment) {
              if (this.form.attachment) {
                this.update()
              } else {
                this.error = '添付資料を設定してください。'
              }
            } else {
              this.update()
            }
          } else { // 新規
            this.post()
          }
        } else {
          this.error = 'サムネイルを設定してください。'
        }
      }
    },
    async fetch() {
      const accessToken = await this.$auth.getTokenSilently();
      axios
        .get(`/api/video/${this.uuid}`, {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
        .then((response) => {
          this.form.title = response.data.title
          this.attachment = response.data.attachment
        })
        .catch(error => {
          this.error = error.response.data.error
          console.log(error)
        })
        .finally(() => {
          this.loading = false
        });
    },
    async post() {
      this.loading = true

      const form = new FormData()
      form.append('video', this.form.video)
      form.append('title', this.form.title)
      form.append('thumb', this.$refs.pictureInput.file)
      if (this.form.attachment) {
        form.append('attachment', this.form.attachment)
      }

      const accessToken = await this.$auth.getTokenSilently();
      axios
        .post("/api/video", form, {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
        .then(() => {
          this.back()
        })
        .catch(error => {
          this.error = error.response.data.error
          console.log(error)
        })
        .finally(() => {
          this.loading = false
        });
    },
    async update() {
      this.loading = true

      const form = new FormData()

      if (this.changeVideo) {
        form.append('video', this.form.video)
      }

      form.append('title', this.form.title)

      if (this.changeThumb) {
        form.append('thumb', this.$refs.pictureInput.file)
      }

      if (this.changeAttachment||this.deleteAttachment) {
        if (this.changeAttachment) {
          form.append('attachment', this.form.attachment)
        } else if (this.deleteAttachment) {
          form.append('deleteAttachment', true)
        }
      }

      const accessToken = await this.$auth.getTokenSilently();
      axios
        .post(`/api/video/${this.uuid}`, form, {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
        .then(() => {
          this.back()
        })
        .catch(error => {
          this.error = error.response.data.error
          console.log(error)
        })
        .finally(() => {
          this.loading = false
        });
    },
    change() {
      this.changeThumb = true
      this.error = ''
    },
    setChangeAttachment() {
      this.changeAttachment = true
    },
    setDeleteAttachment() {
      this.deleteAttachment = true
      this.attachment = ''
    }
  }
}
</script>

<style scoped>
.picture-input {
  text-align: unset;
}

.picture-input >>> .picture-inner-text {
  font-size: 1.5em;
  color: #fff
}

.picture-input >>> .preview-container {
  margin: 0;
}

.picture-input >>> .picture-preview {
  background-color: #616161!important;
}

</style>